import * as React from 'react';

import { noop } from 'shared/entities/common/utils';

import { DateRangePickerModel } from './DateRangePickerModel';

const DateRangePickerContext = React.createContext<{
  store: DateRangePickerModel;
}>({
  store: new DateRangePickerModel({ value: null, onChange: noop })
});

const DateRangePickerProvider = DateRangePickerContext.Provider;

const useDateRangePicker = (): DateRangePickerModel => {
  const context = React.useContext(DateRangePickerContext);

  return context.store;
};

export { DateRangePickerProvider, useDateRangePicker, DateRangePickerModel };
